import classNames from 'classnames'
import React from 'react'

import './index.scss'

export default ({ className = '', variant = 'full' }) => {
  return (
    <svg
      width="753"
      height="915"
      viewBox="0 0 753 915"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames('js-logo', `variant-${variant}`, className)}
    >
      <path
        d="M628.321 691.893H109.573V165.474H628.321V691.893ZM111.953 689.481H625.941V689.478H625.944V167.889H625.941V167.886H111.953V167.889H111.95V689.478H111.953V689.481Z"
        fill="white"
        stroke="white"
        stroke-width="0.00590958"
      />
      <path
        d="M507.215 401.498C488.254 402.997 472.343 409.818 460.501 421.548C448.296 433.617 442.484 448.371 442.484 467.066C442.484 495.026 453.987 514.568 479.608 530.072C486.123 533.99 495.01 538.247 510.364 544.849C531.287 553.822 539.061 558.079 544.025 563.4C550.152 569.954 551.847 580.451 547.997 588.457C547.246 590.005 545.284 592.617 543.541 594.383C537.608 600.357 528.284 603.501 516.684 603.501C497.117 603.501 482.514 595.471 470.769 578.13C469.171 575.832 467.718 573.921 467.5 573.921C467.04 573.921 428.85 595.931 428.051 596.68C427.542 597.14 427.954 598.18 429.915 601.397C445.172 627.058 469.001 642.102 501.234 646.407C509.661 647.568 525.475 647.52 533.539 646.407C553.809 643.553 569.017 636.829 580.81 625.414C593.355 613.345 599.53 597.696 599.53 578.105C599.53 565.577 597.472 555.806 592.798 546.131C589.577 539.504 586.38 535.054 580.859 529.443C570.276 518.728 556.569 510.602 529.229 498.871C508.547 489.995 501.621 486.198 497.069 481.336C492.71 476.668 490.845 471.202 491.257 464.406C491.62 458.988 493.121 455.336 496.415 451.781C501.185 446.629 506.707 444.452 515.231 444.525C524.918 444.525 531.19 447.04 537.559 453.45C539.811 455.651 542.717 459.206 544.073 461.359C545.623 463.826 546.786 465.156 547.173 465.011C548.481 464.454 584.951 440.897 584.951 440.558C584.951 440.365 583.087 437.463 580.835 434.052C576.015 426.845 567.346 417.823 561.364 413.857C550.321 406.528 538.528 402.78 522.981 401.619C515.401 400.941 514.408 400.941 507.215 401.498Z"
        fill="white"
      />
      <path
        d="M351.022 492.558L350.877 581.176L349.763 585.336C348.31 590.802 346.59 594.067 343.587 597.066C339.374 601.274 333.949 603.04 324.916 603.088C312.009 603.137 304.283 597.671 295.299 582.337C293.846 579.942 292.538 577.983 292.393 578.032C292.199 578.128 283.118 583.594 272.22 590.149L252.387 602.169L253.888 605.168C262.873 623.066 278.42 636.586 297.139 642.802C316.9 649.357 342.304 648.776 360.927 641.303C383.255 632.281 396.356 613.634 399.819 585.916C400.109 583.111 400.327 551.79 400.327 492.848V403.988H351.216L351.022 492.558Z"
        fill="white"
      />
      <path
        d="M111.919 275.222L111.919 167.802L165.697 221.512L111.919 275.222Z"
        fill="white"
      />
      <path
        d="M165.692 221.515L165.692 328.935L111.914 275.225L165.692 221.515Z"
        fill="white"
      />
      <path
        d="M327.018 275.225L219.461 275.225L273.24 221.515L327.018 275.225Z"
        fill="white"
      />
      <path
        d="M380.801 328.932L273.245 328.932L327.023 275.222L380.801 328.932Z"
        fill="white"
      />
      <path
        d="M434.579 167.799V275.219L380.801 221.509L434.579 167.799Z"
        fill="white"
      />
      <path
        d="M327.024 167.799V275.219L273.246 221.509L327.024 167.799Z"
        fill="white"
      />
      <path
        d="M219.475 275.222V382.642L165.697 328.932L219.475 275.222Z"
        fill="white"
      />
      <path
        d="M273.247 328.929V436.349L219.469 382.639L273.247 328.929Z"
        fill="white"
      />
      <path
        d="M111.914 382.642L219.47 382.642L165.692 436.352L111.914 382.642Z"
        fill="white"
      />
      <path
        d="M111.914 490.064L219.47 490.064L165.692 543.774L111.914 490.064Z"
        fill="white"
      />
      <path
        d="M109.564 276.225L0.00418614 276.225L54.7843 221.515L109.564 276.225Z"
        fill="white"
      />
      <path
        d="M0.00585697 54.7182L109.566 54.7182L54.786 109.763L0.00585697 54.7182Z"
        fill="white"
      />
      <path
        d="M165.018 109.761L273.91 109.761L219.464 165.807L165.018 109.761Z"
        fill="white"
      />
      <path
        d="M327.007 56.0517L327.007 165.473L273.229 110.763L327.007 56.0517Z"
        fill="white"
      />
      <path
        d="M54.786 109.763L54.786 221.52L0.00586916 165.641L54.786 109.763Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.556 164.103L109.909 165.472L165.023 109.76L54.7951 109.76L56.8135 111.8L160.447 111.8L108.556 164.103Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M431.64 165.478H434.58L380.802 110.768L327.023 165.478H330.609L332.957 163.089H332.894L380.802 114.112L380.951 114.263L381.124 114.087L431.64 165.478Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M109.563 278.15L109.563 275.223L54.7832 328.934L109.563 382.644L109.563 379.067L107.171 376.722L107.171 376.78L58.1322 328.934L58.2811 328.787L58.0996 328.609L109.563 278.15Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M109.563 385.571L109.563 382.644L54.7832 436.354L109.563 490.064L109.563 486.488L107.171 484.143L107.171 484.201L58.1322 436.354L58.2811 436.208L58.0996 436.03L109.563 385.571Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.7902 218.31L54.7902 221.353L109.57 165.474L54.7902 109.596L54.7902 113.319L57.1823 115.759L57.1823 115.696L106.221 165.474L106.071 165.628L106.254 165.814L54.7902 218.31Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M269.646 109.751H272.58L218.801 55.04L165.023 109.751H168.603L170.952 107.362H170.894L218.801 58.3848L218.948 58.5331L219.125 58.3535L269.646 109.751Z"
        fill="white"
      />
      <path
        d="M165.018 -0.000376261L165.018 109.755L109.57 54.8773L165.018 -0.000376261ZM162.597 103.764L162.597 5.51136L112.96 54.8773L162.597 103.764Z"
        fill="white"
      />
      <path
        d="M273.246 221.514H165.689L219.468 167.804L273.246 221.514ZM171.56 219.168H267.844L219.468 171.087L171.56 219.168Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M437.51 167.812L434.577 167.812L488.355 221.522L542.133 167.812L538.542 167.812L536.194 170.158L536.262 170.158L488.355 218.239L488.203 218.088L488.026 218.265L437.51 167.812Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M327.021 272.289L327.021 275.224L380.799 221.514L327.021 167.804L327.021 171.388L329.369 173.733L329.369 173.667L377.511 221.514L377.361 221.664L377.535 221.838L327.021 272.289Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M115.228 382.664L167.267 330.54L165.678 328.954L111.9 382.664H115.228Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M165.689 225.183L168.037 227.522L168.037 227.386L216.179 275.232L216.064 275.348L217.71 276.987L219.467 275.232L165.689 221.522L165.689 225.183Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M219.456 278.884L221.805 281.223L221.805 281.088L269.947 328.935L269.831 329.051L271.477 330.69L273.234 328.935L219.456 275.225L219.456 278.884Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M167.286 434.765L165.689 436.359L219.467 490.069L219.467 382.649L217.13 384.984L217.13 484.401L167.286 434.765Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M164.189 434.858L111.911 487.07L111.911 490.067L165.689 436.356L164.189 434.858Z"
        fill="white"
      />
      <path
        d="M110.842 815.598V741.856H135.156C150.303 741.856 161.863 746.341 161.863 760.092C161.863 766.869 158.175 773.745 151.898 776.037V776.435C159.77 778.328 165.649 784.009 165.649 793.874C165.649 808.722 153.293 815.598 137.149 815.598H110.842ZM125.59 771.851H134.16C143.527 771.851 147.513 768.164 147.513 762.185C147.513 755.708 143.228 753.217 134.359 753.217H125.59V771.851ZM125.59 804.238H135.854C145.819 804.238 151.3 800.65 151.3 793.077C151.3 785.902 146.018 782.813 135.854 782.813H125.59V804.238ZM207.967 816.993C189.93 816.993 179.268 806.928 179.268 782.514V741.856H193.916V783.809C193.916 799.056 199.298 804.238 207.967 804.238C216.637 804.238 222.317 799.056 222.317 783.809V741.856H236.467V782.514C236.467 806.928 226.004 816.993 207.967 816.993ZM255.206 815.598V741.856H275.435C297.956 741.856 311.807 753.516 311.807 778.428C311.807 803.241 297.956 815.598 276.232 815.598H255.206ZM269.954 803.739H274.439C288.29 803.739 296.76 796.365 296.76 778.428C296.76 760.491 288.29 753.615 274.439 753.615H269.954V803.739ZM316.218 815.598L339.836 741.856H357.175L380.792 815.598H365.346L354.783 777.232C352.591 769.559 350.498 760.989 348.405 753.117H348.007C346.014 761.089 343.921 769.559 341.729 777.232L331.166 815.598H316.218ZM330.867 796.664V785.304H365.944V796.664H330.867ZM390.52 815.598V741.856H414.735C430.978 741.856 443.534 747.537 443.534 765.075C443.534 781.916 430.978 789.39 415.134 789.39H405.268V815.598H390.52ZM405.268 777.731H414.137C424.302 777.731 429.184 773.446 429.184 765.075C429.184 756.405 423.803 753.615 413.639 753.615H405.268V777.731ZM457.983 815.598V741.856H503.224V754.113H472.731V771.154H498.54V783.61H472.731V803.241H504.32V815.598H457.983ZM542.31 816.993C532.345 816.993 522.579 813.206 515.405 806.33L523.875 796.166C529.057 801.049 536.132 804.238 542.609 804.238C550.282 804.238 554.268 800.949 554.268 795.867C554.268 790.386 549.784 788.592 543.207 785.802L533.342 781.617C525.967 778.627 518.394 772.549 518.394 761.886C518.394 749.828 529.057 740.561 543.904 740.561C552.474 740.561 561.044 743.949 567.023 750.028L559.649 759.295C554.866 755.409 549.983 753.217 543.904 753.217C537.427 753.217 533.342 756.106 533.342 760.89C533.342 766.171 538.623 768.164 544.901 770.655L554.567 774.641C563.436 778.328 569.315 784.108 569.315 794.671C569.315 806.729 559.251 816.993 542.31 816.993ZM595.294 815.598V754.113H574.468V741.856H630.87V754.113H610.043V815.598H595.294Z"
        fill="white"
      />
      <path
        d="M117.634 902.178C110.836 902.178 106.305 899.472 103.158 894.059L109.578 889.276C111.34 892.675 113.794 894.122 116.438 894.122C120.592 894.122 122.731 891.982 122.731 885.563V854.723H132.046V886.318C132.046 895.066 127.578 902.178 117.634 902.178ZM153.027 902.178C145.411 902.178 142.076 896.954 142.076 888.08V866.115H151.327V886.947C151.327 892.36 152.838 894.248 156.3 894.248C159.195 894.248 161.083 892.989 163.474 889.842V866.115H172.663V901.297H165.111L164.418 896.262H164.23C161.146 899.849 157.81 902.178 153.027 902.178ZM182.589 901.297V866.115H190.079L190.834 870.772H191.023C194.044 867.751 197.694 865.234 202.478 865.234C210.03 865.234 213.366 870.521 213.366 879.332V901.297H204.114V880.528C204.114 874.989 202.541 873.164 199.142 873.164C196.247 873.164 194.422 874.549 191.841 877.066V901.297H182.589ZM238.265 902.178C228.384 902.178 220.706 895.381 220.706 883.737C220.706 872.283 228.762 865.234 237.069 865.234C246.825 865.234 251.797 872.283 251.797 882.038C251.797 883.8 251.608 885.437 251.419 886.318H229.643C230.461 892.108 234.237 895.066 239.461 895.066C242.293 895.066 244.811 894.185 247.391 892.612L250.475 898.339C247.013 900.73 242.608 902.178 238.265 902.178ZM229.517 880.15H243.929C243.929 875.367 241.79 872.346 237.258 872.346C233.545 872.346 230.272 874.989 229.517 880.15ZM271.409 901.297V896.01C283.556 884.367 291.549 876.5 291.549 869.702C291.549 865.108 289.094 862.339 284.626 862.339C281.164 862.339 278.458 864.668 276.066 867.185L270.968 862.15C275.248 857.556 279.465 855.101 285.821 855.101C294.57 855.101 300.486 860.64 300.486 869.262C300.486 877.129 293.122 885.374 284.814 894.059C287.143 893.807 290.227 893.493 292.43 893.493H302.626V901.297H271.409ZM325.714 902.178C316.839 902.178 308.909 895.444 308.909 879.835C308.909 862.528 317.595 855.101 326.972 855.101C332.7 855.101 336.853 857.493 339.623 860.325L334.714 865.926C333.077 864.038 330.245 862.591 327.539 862.591C321.937 862.591 317.406 866.87 317.406 879.835C317.406 891.101 320.93 895.192 325.462 895.192C329.049 895.192 331.881 892.486 331.881 887.136C331.881 882.038 329.238 879.709 325.21 879.709C322.693 879.709 319.798 881.094 317.406 885.059L317.028 878.765C319.546 875.241 323.763 873.164 326.909 873.164C334.714 873.164 340.315 877.633 340.315 887.136C340.315 896.388 333.644 902.178 325.714 902.178ZM346.032 886.633V880.024H363.277V886.633H346.032ZM368.949 901.297V896.01C381.096 884.367 389.089 876.5 389.089 869.702C389.089 865.108 386.634 862.339 382.166 862.339C378.704 862.339 375.998 864.668 373.606 867.185L368.508 862.15C372.788 857.556 377.005 855.101 383.361 855.101C392.11 855.101 398.026 860.64 398.026 869.262C398.026 877.129 390.662 885.374 382.354 894.059C384.683 893.807 387.767 893.493 389.97 893.493H400.166V901.297H368.949ZM421.932 902.178C412.995 902.178 406.387 897.08 406.387 889.779C406.387 884.115 410.1 880.528 414.317 878.262V878.01C410.855 875.43 408.149 872.094 408.149 867.374C408.149 859.821 414.128 855.101 422.247 855.101C430.491 855.101 435.778 860.01 435.778 867.437C435.778 871.842 432.757 875.493 429.799 877.57V877.884C434.016 880.276 437.603 883.675 437.603 889.779C437.603 896.828 431.31 902.178 421.932 902.178ZM424.89 875.367C427.03 873.038 428.226 870.647 428.226 868.003C428.226 864.227 425.897 861.584 422.058 861.584C418.848 861.584 416.331 863.598 416.331 867.374C416.331 871.528 420.044 873.416 424.89 875.367ZM422.121 895.633C426.149 895.633 428.981 893.43 428.981 889.402C428.981 884.87 424.575 883.297 418.659 880.779C416.142 882.73 414.317 885.5 414.317 888.709C414.317 892.926 417.778 895.633 422.121 895.633ZM445.775 914.765L443.887 909.73C448.796 907.905 451.503 904.57 451.44 900.856L451.125 894.311L454.398 899.723C453.454 900.668 452.195 901.108 450.81 901.108C447.789 901.108 445.02 899.094 445.02 895.633C445.02 892.297 447.726 890.157 451.062 890.157C455.279 890.157 457.67 893.556 457.67 899.22C457.67 906.647 453.454 912.248 445.775 914.765ZM477.921 901.297V896.01C490.068 884.367 498.061 876.5 498.061 869.702C498.061 865.108 495.606 862.339 491.138 862.339C487.676 862.339 484.97 864.668 482.578 867.185L477.48 862.15C481.76 857.556 485.977 855.101 492.333 855.101C501.082 855.101 506.998 860.64 506.998 869.262C506.998 877.129 499.634 885.374 491.326 894.059C493.655 893.807 496.739 893.493 498.942 893.493H509.138V901.297H477.921ZM530.967 902.178C521.338 902.178 515.17 893.87 515.17 878.451C515.17 863.031 521.338 855.101 530.967 855.101C540.47 855.101 546.701 863.094 546.701 878.451C546.701 893.87 540.47 902.178 530.967 902.178ZM530.967 894.94C534.995 894.94 537.953 891.101 537.953 878.451C537.953 865.8 534.995 862.276 530.967 862.276C526.939 862.276 523.918 865.8 523.918 878.451C523.918 891.101 526.939 894.94 530.967 894.94ZM552.167 901.297V896.01C564.314 884.367 572.307 876.5 572.307 869.702C572.307 865.108 569.852 862.339 565.384 862.339C561.922 862.339 559.216 864.668 556.824 867.185L551.726 862.15C556.006 857.556 560.223 855.101 566.579 855.101C575.328 855.101 581.244 860.64 581.244 869.262C581.244 877.129 573.88 885.374 565.572 894.059C567.901 893.807 570.985 893.493 573.188 893.493H583.384V901.297H552.167ZM607.793 901.297V873.919C607.793 871.213 608.045 866.87 608.171 864.164H607.919C606.723 866.619 605.465 868.947 604.143 871.528L596.968 882.919H621.954V890.031H587.968V883.675L605.276 855.919H616.416V901.297H607.793Z"
        fill="white"
      />
    </svg>

    /* 
    <svg
      version="1.1"
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 283.5 283.5"
      className={classNames('js-logo', `variant-${variant}`, className)}
    >
      <g id="Yellow_square_1_">
        <path
          className="outline"
          d="M261.7,283.5H44V65.8h217.7V283.5z M45,282.5h215.7V66.8H45V282.5z"
        />
      </g>
      <g
        id="JS_1_"
        transform="translate(0.000000,1052.000000) scale(0.100000,-0.100000)"
      >
        <path
          className="letter"
          d="M2072.4,8884.8c-78.3-6.2-144-34.4-192.9-82.9c-50.4-49.9-74.4-110.9-74.4-188.2c0-115.6,47.5-196.4,153.3-260.5
	 c26.9-16.2,63.6-33.8,127-61.1c86.4-37.1,118.5-54.7,139-76.7c25.3-27.1,32.3-70.5,16.4-103.6c-3.1-6.4-11.2-17.2-18.4-24.5
	 c-24.5-24.7-63-37.7-110.9-37.7c-80.8,0-141.1,33.2-189.6,104.9c-6.6,9.5-12.6,17.4-13.5,17.4c-1.9,0-159.6-91-162.9-94.1
	 c-2.1-1.9-0.4-6.2,7.7-19.5c63-106.1,161.4-168.3,294.5-186.1c34.8-4.8,100.1-4.6,133.4,0c83.7,11.8,146.5,39.6,195.2,86.8
	 c51.8,49.9,77.3,114.6,77.3,195.6c0,51.8-8.5,92.2-27.8,132.2c-13.3,27.4-26.5,45.8-49.3,69c-43.7,44.3-100.3,77.9-213.2,126.4
	 c-85.4,36.7-114,52.4-132.8,72.5c-18,19.3-25.7,41.9-24,70c1.5,22.4,7.7,37.5,21.3,52.2c19.7,21.3,42.5,30.3,77.7,30
	 c40,0,65.9-10.4,92.2-36.9c9.3-9.1,21.3-23.8,26.9-32.7c6.4-10.2,11.2-15.7,12.8-15.1c5.4,2.3,156,99.7,156,101.1
	 c0,0.8-7.7,12.8-17,26.9c-19.9,29.8-55.7,67.1-80.4,83.5c-45.6,30.3-94.3,45.8-158.5,50.6
	 C2106.2,8887.1,2102.1,8887.1,2072.4,8884.8z"
        />
        <path
          className="letter"
          d="M1427.4,8508.3l-0.6-366.4l-4.6-17.2c-6-22.6-13.1-36.1-25.5-48.5c-17.4-17.4-39.8-24.7-77.1-24.9
	 c-53.3-0.2-85.2,22.4-122.3,85.8c-6,9.9-11.4,18-12,17.8c-0.8-0.4-38.3-23-83.3-50.1l-81.9-49.7l6.2-12.4
	 c37.1-74,101.3-129.9,178.6-155.6c81.6-27.1,186.5-24.7,263.4,6.2c92.2,37.3,146.3,114.4,160.6,229c1.2,11.6,2.1,141.1,2.1,384.8
	 v367.4h-101.5h-101.3L1427.4,8508.3z"
        />
      </g>
      <g id="Blue_triangles_1_">
        <g className="inner">
          <path d="M110.7,88.4H64.9l22.9-22.9L110.7,88.4z M67.4,87.4h41L87.8,67L67.4,87.4z" />
        </g>
        <g className="inner">
          <path d="M89,153.5H43.2l22.9-22.9L89,153.5z M45.7,152.5h41L66.1,132L45.7,152.5z" />
        </g>
        <g className="inner">
          <path d="M44,197.6v-45.8l22.9,22.9L44,197.6z M45,154.2v41l20.5-20.5L45,154.2z" />
        </g>
        <g className="inner">
          <path d="M87.3,154.2v-45.8l22.9,22.9L87.3,154.2z M88.3,110.8v41l20.5-20.5L88.3,110.8z" />
        </g>
        <g className="inner">
          <path d="M152.8,88.7l-22.9-22.9h45.8L152.8,88.7z M132.4,66.8l20.5,20.5l20.5-20.5H132.4z" />
        </g>
        <g className="outer">
          <path d="M44.5,67L21.6,44.1h45.8L44.5,67z M24,45.1l20.5,20.5l20.5-20.5H24z" />
        </g>
      </g>
      <g id="Green_triangles_1_">
        <g className="inner">
          <polygon points="66.2,109.6 66.2,131.3 44.5,109.6 66.2,87.9 		" />
          <path d="M66.7,132.5l-22.9-22.9l22.9-22.9V132.5z M45.2,109.6l20.5,20.5v-41L45.2,109.6z" />
        </g>
        <g className="inner">
          <polygon points="131.2,87.9 131.2,109.6 109.5,87.9 131.2,66.2 		" />
          <path d="M131.7,110.8l-22.9-22.9L131.7,65V110.8z M110.2,87.9l20.5,20.5v-41L110.2,87.9z" />
        </g>
        <g className="inner">
          <polygon points="131.1,131.3 109.5,131.3 131.1,109.6 152.8,131.3 		" />
          <path d="M154,131.8h-45.8l22.9-22.9L154,131.8z M110.7,130.8h41l-20.5-20.5L110.7,130.8z" />
        </g>
        <g className="inner">
          <polygon points="66.1,196.3 87.8,196.3 66.1,218 44.5,196.3 		" />
          <path d="M66.1,218.7l-22.9-22.9h45.1v0.3v0.4L66.1,218.7z M45.7,196.8l20.5,20.5l20.5-20.5H45.7z" />
        </g>
        <g className="inner">
          <polygon points="174.5,87.9 174.5,109.6 152.8,87.9 174.5,66.2 		" />
          <path d="M175,110.8l-22.9-22.9l22.4-22.4l0.2,0.2h0.3V110.8z M153.5,87.9l20.5,20.5v-41L153.5,87.9z" />
        </g>
        <g className="outer">
          <polygon points="87.8,44.6 109.5,44.6 87.8,66.3 66.1,44.6 		" />
          <path d="M87.8,67L64.9,44.1h45.8L87.8,67z M67.4,45.1l20.5,20.5l20.5-20.5H67.4z" />
        </g>
        <g className="outer">
          <polygon points="22.8,66.3 22.8,87.9 1.1,66.3 22.8,44.6 		" />
          <path d="M23.3,89.2L0.4,66.3l22.9-22.9V89.2z M1.8,66.3l20.5,20.5v-41L1.8,66.3z" />
        </g>
      </g>
      <g id="Red_triangles_1_">
        <g className="inner">
          <polygon points="44.5,87.9 44.5,66.2 66.1,87.9 44.5,109.6 		" />
          <path d="M44,110.8V65l22.9,22.9L44,110.8z M45,67.5v41l20.5-20.5L45,67.5z" />
        </g>
        <g className="inner">
          <polygon points="109.5,109.6 87.8,109.6 109.5,87.9 131.2,109.6 		" />
          <path d="M132.4,110.1H86.6l22.9-22.9L132.4,110.1z M89.1,109.1h41l-20.5-20.5L89.1,109.1z" />
        </g>
        <g className="inner">
          <polygon points="87.8,131.3 87.8,153 66.1,131.3 87.8,109.6 		" />
          <path d="M88.3,154.2l-22.9-22.9l22.9-22.9V154.2z M66.9,131.3l20.5,20.5v-41L66.9,131.3z" />
        </g>
        <g className="inner">
          <polygon points="66.1,153 87.8,153 66.1,174.7 44.5,153 		" />
          <path d="M66.1,175.4l-22.9-22.9H89L66.1,175.4z M45.7,153.5l20.5,20.5l20.5-20.5H45.7z" />
        </g>
        <g className="inner">
          <polygon points="109.5,153 109.5,174.7 87.8,153 109.5,131.3 		" />
          <path d="M110,175.9L87.1,153l22.9-22.9V175.9z M88.5,153l20.5,20.5v-41L88.5,153z" />
        </g>
        <g className="outer">
          <polygon points="131.2,44.6 131.2,66.3 109.5,44.6 131.2,22.9 		" />
          <path d="M131.7,67.5l-22.9-22.9l22.9-22.9V67.5z M110.2,44.6L130.7,65v-41L110.2,44.6z" />
        </g>
        <g className="outer">
          <polygon points="22.8,109.6 1.1,109.6 22.8,87.9 44.5,109.6 		" />
          <path d="M45.7,110.1H-0.1l22.9-22.9L45.7,110.1z M2.3,109.1h41L22.8,88.6L2.3,109.1z" />
        </g>
        <g className="outer">
          <polygon points="22.8,22.9 44.5,22.9 22.8,44.6 1.1,22.9 		" />
          <path d="M22.8,45.3L-0.1,22.4h45.8L22.8,45.3z M2.3,23.4l20.5,20.5l20.5-20.5H2.3z" />
        </g>
      </g>
      <g id="Yellow_triangles_1_">
        <g className="outer">
          <path d="M175.7,66.8h-45.8l22.9-22.9L175.7,66.8z M132.4,65.8h41l-20.5-20.5L132.4,65.8z" />
        </g>
        <g className="outer">
          <path d="M110.7,45.1H64.9l22.9-22.9L110.7,45.1z M67.4,44.1h41L87.8,23.6L67.4,44.1z" />
        </g>
        <g className="outer">
          <path d="M89,66.8H43.2l22.9-22.9L89,66.8z M45.7,65.8h41L66.1,45.3L45.7,65.8z" />
        </g>
        <g className="outer">
          <path d="M45,154.2l-22.9-22.9L45,108.4V154.2z M23.5,131.3l20.5,20.5v-41L23.5,131.3z" />
        </g>
      </g>
      <g id="White_triangles_1_">
        <g>
          <path d="M66.1,88.7L43.2,65.8H89L66.1,88.7z M45.7,66.8l20.5,20.5l20.5-20.5H45.7z" />
        </g>
        <g>
          <path d="M130.6,110.9V65.1L153.5,88L130.6,110.9z M131.7,67.5v41L152.1,88L131.7,67.5z" />
        </g>
        <g>
          <path d="M65.7,132.6V86.8l22.9,22.9L65.7,132.6z M66.7,89.2v41l20.5-20.5L66.7,89.2z" />
        </g>
        <g>
          <path d="M109.5,132l-22.9-22.9h45.8L109.5,132z M89.1,110.1l20.5,20.5l20.5-20.5H89.1z" />
        </g>
        <g>
          <path d="M44,154.2v-45.8l22.9,22.9L44,154.2z M45,110.8v41l20.5-20.5L45,110.8z" />
        </g>
        <g>
          <path d="M88.1,196.8l-0.3,0.3l-22.4-22.4l22.9-22.9v44.8L88.1,196.8z M66.9,174.7l20.5,20.5v-41L66.9,174.7z" />
        </g>
        <g>
          <path d="M196.2,88.7l-22.9-22.9h45.8L196.2,88.7z M175.7,66.8l20.5,20.5l20.5-20.5H175.7z" />
        </g>
        <g className="outer">
          <path d="M45,110.8L22.1,87.9L45,65V110.8z M23.5,87.9L44,108.4v-41L23.5,87.9z" />
        </g>
        <g className="outer">
          <path d="M66.6,45.8L43.7,22.9L66.6,0V45.8z M45.2,22.9l20.5,20.5v-41L45.2,22.9z" />
        </g>
        <g className="outer">
          <path d="M45,197.6l-22.9-22.9L45,151.8V197.6z M23.5,174.7L44,195.2v-41L23.5,174.7z" />
        </g>
      </g>
    </svg> */
  )
}
